<div class="header">
      <div flex fxLayout="row">
        <div fxFlex="100">
            <h1>Reservas</h1>
        </div>
      </div>
      
      <div class="header-container">
          <div class="pt-3">
              <button type="button" mat-raised-button color="primary" class="btn-action" (click)="newReserva()" [disabled]="btnReservaDisabled">Reservar Turno</button>
              <button type="button" mat-raised-button color="white" class="ml-2" routerLink='/reservas-list'> <i class="material-icons">list</i> Lista Reservas</button>
              <button type="button" mat-raised-button color="white" class="ml-2" (click)="reservaRecurrente()">Reserva recurrente</button>
          </div>
          <div  class="text-right">
            <table>
              <tr>
                <td>
                    <button type="button" mat-icon-button (click)="prevDay()"><i class="material-icons">chevron_left</i></button>
                </td>
                <td>
                    <mat-form-field>
                        <input class="text-center" matInput [matDatepicker]="dp"  (dateChange)="addEvent('change', $event)" [formControl]="currentDateSelector">
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp disabled="false"></mat-datepicker>
                    </mat-form-field>
                </td>
                <td>
                    <button type="button" mat-icon-button (click)="nextDay()"><i class="material-icons">chevron_right</i></button>
                </td>
              </tr>
            </table>
          </div>
      </div>

      <div flex fxLayout="row" fxLayoutGap="15px">
          <div class="col-1" fxFlex="0 1 80px">
              <mat-card class="text-muted-1">Hora</mat-card>
          </div>
          <div fxFlex="" *ngFor="let cancha of canchas">
             <mat-card class="text-muted-1">{{ cancha.name }}</mat-card>
        </div>
    </div>
</div>

<div class="calendar"  #scrollTarget>
    <div flex fxLayout="row" fxLayoutGap="15px" id="content">
        <div class="col-1" fxFlex="0 1 80px">
            <div *ngFor="let hora of day_array" class="time-bucket" id="{{hora}}">
              {{ hora }}
            </div>              
        </div>
        <div fxFlex *ngFor="let cancha of canchas" style="position: relative">
            <app-reservas-cancha [cancha]="cancha" [day_array]="day_array" [day]="currentDay"></app-reservas-cancha>
        </div>
    </div>
</div>
